<template>
	<div v-show="selectedStudy && currentTab" class="TrackRespondents">
		<scheduled-respondents ref="respondentsScheduled" v-if="isRecallScheduled"></scheduled-respondents>
		<unscheduled-respondents ref="respondentUnscheduled" v-else-if="isRecallUnscheduled"></unscheduled-respondents>
		<record-respondents ref="respondentRecord" v-else-if="isRecordStudy && selectedStudy.recordStudyType !== ''"></record-respondents>
	</div>
</template>

<script>
import { utilityService } from '@/services/utilityService.js';
export default {
	name: 'TrackRespondents',
	props: {
	},
	data: () => ({
	}),
	mounted () {
	},
	computed: {
		selectedStudy: function () {
			// This computed property will update the study when the selected study is
			// modified in the store
			// eslint-disable-next-line vue/no-side-effects-in-computed-properties
			return this.$store.getters.getSelectedStudy;
		},
		isRecallScheduled: function () {
			return this.selectedStudy && this.selectedStudy.recallType && this.selectedStudy.recallType.toLowerCase() === this.$createStudyLists.RECALL_TYPE_SCHEDULED.value.toLowerCase();
		},
		isRecallUnscheduled: function () {
			return this.selectedStudy && this.selectedStudy.recallType && this.selectedStudy.recallType.toLowerCase() === this.$createStudyLists.RECALL_TYPE_UNSCHEDULED.value.toLowerCase();
		},
		isRecordStudy: function () {
			return this.selectedStudy && this.selectedStudy.recordStudyType !== '';
		},
		currentTab: function () {
			const tabPosition = {
				tabIndex: parseInt(this.$store.getters.getCurrentStudyTabIndex),
				subTabIndex: parseInt(this.$store.getters.getCurrentStudySubTabIndex)
			};

			this.checkTabMatch(tabPosition);

			return tabPosition;
		}
	},
	methods: {
		async checkTabMatch ({ tabIndex, subTabIndex } = {}) {
			const tabsPos = await utilityService.getTabsPositionByName('Track Respondents', this.$studyTabConfig);
			if (tabsPos.tabPos === tabIndex && tabsPos.subtabPos === subTabIndex) {
				if (this.isRecallScheduled) {
					setTimeout(() => {
						this.$refs.respondentsScheduled.$refs.firstFocusable.focus();
					}, '350');
				} else if (this.isRecallUnscheduled) {
					setTimeout(() => {
						this.$refs.respondentUnscheduled.$refs.firstFocusable.focus();
					}, '350');
					// this.$refs.respondentUnscheduled.$refs.firstFocusable.focus();
				} else if (this.isRecordStudy) {
					setTimeout(() => {
						this.$refs.respondentRecord.$refs.firstFocusable.focus();
					}, '350');
				}
			}
		}
	}
}
</script>

<style>
</style>
